import { Observable } from 'rxjs';
import { InstructionsTypeModel, InstructionsRequest } from '@src/core/domain/instructions/instructionsType.model';

export abstract class InstructionsTypeRepository {
  abstract getInstructionsTypes(): Observable<InstructionsTypeModel>;
  abstract setInstructionsIndex(obj: InstructionsRequest): Observable<InstructionsTypeModel>;
}
